import React, {Component} from 'react';
import {connect} from 'react-redux';
import DatePicker from 'react-datepicker';
import {Card, Header, Select, Form, Button, Dimmer} from 'semantic-ui-react';
import {noTimeZoneShortISODate, dateFormatPicker} from '../../../common/constants/datesFormat';
import {hasAccessPermission} from '../../../common/permissions/validations';
import {resources, scopes} from '../../../common/permissions/dictionary';
import {DEALER_OPTIONS_LIST, TYPE_LIST} from '../static/constansDealerOptions';
import {convertDateToSpecificFormat} from '../../../common/util/date';
import {paths} from '../../../common/dictionaries/urls';
import {Actions} from '../../../common/actions';
import Loader from '../../../common/components/loader';
import Table from './Table';
import './styles.scss';

class ManintainFTRs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'startDate': null,
      'endDate': null,
      'dealer': 'ALL',
      'type': 'ALL',
      'filters': '',
    };
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    if (!hasAccessPermission(this.props.permissions, resources.MaintainFormsServices, scopes.See)) {
      this.props.navigateTo(paths.AccessDenied);
    }
    this.props.clearPublishedAnswersList();
  }

  componentWillUnmount() {
    this.props.clearPublishedAnswersList();
  }

  handleChange(field, value) {
    this.setState({
      [field]: value,
    });
  }

  handleSearch() {
    const {startDate, endDate, dealer, type} = this.state;
    if (startDate && endDate) {
      const filters = {
        'startDate': convertDateToSpecificFormat(startDate, noTimeZoneShortISODate),
        'endDate': convertDateToSpecificFormat(endDate, noTimeZoneShortISODate),
        'dealerId': dealer === 'ALL' ? null : dealer,
        'formType': type === 'ALL' ? null : type,
      };
      this.props.fetchPublishedAnswersList(filters);
      this.setState({filters});
    } else {
      this.props.addMessageBoxError('Por favor ingrese la fecha de inicial y final');
    }
  }

  renderLoaderOrTable() {
    const {forms, loading} = this.props;
    const {filters} = this.state;
    if (loading) {
      return (
        <Dimmer active inverted>
          <Loader inverted />
        </Dimmer>
      );
    }

    return (
      <Table
        forms={forms}
        filters={filters}
      />
    );
  }

  render() {
    const {startDate, endDate, dealer, type} = this.state;

    return (
      <div className='maintain-ftrs'>
        <Card raised fluid>
          <div className='maintain-fts-container-header'>
            <Header as='h2'>Mantenimiento de Formularios</Header>
          </div>
          <div className='twc-search-container'>
            <Form>
              <Form.Group widths='five'>
                <Form.Input fluid label='Fecha de inicial'>
                  <DatePicker
                    placeholderText='Fecha de inicial'
                    className='tcc-datepicker'
                    showYearDropdown
                    selected={startDate}
                    dateFormat={dateFormatPicker}
                    onChange={(value) => this.handleChange('startDate', value)}
                    locale='es'
                  />
                </Form.Input>
                <Form.Input fluid label='Fecha de final'>
                  <DatePicker
                    placeholderText='Fecha de final'
                    className='tcc-datepicker'
                    showYearDropdown
                    selected={endDate}
                    dateFormat={dateFormatPicker}
                    minDate={startDate}
                    onChange={(value) => this.handleChange('endDate', value)}
                    locale='es'
                  />
                </Form.Input>
                <Form.Field
                  control={Select}
                  options={DEALER_OPTIONS_LIST}
                  label='Consesionario'
                  placeholder='Consesionario'
                  value={dealer}
                  onChange={(e, {value}) =>
                    this.handleChange('dealer', value)
                  }
                />
                <Form.Field
                  control={Select}
                  options={TYPE_LIST}
                  label='tipo'
                  placeholder='tipo'
                  value={type}
                  onChange={(e, {value}) => this.handleChange('type', value)}
                />
                <div className='twc-btn-search'>
                  <Button
                    onClick={this.handleSearch}
                    type='submit'
                    color='green'
                  >
                    BUSCAR
                  </Button>
                </div>
              </Form.Group>
            </Form>
          </div>
        </Card>
        <Card raised fluid>
          {this.renderLoaderOrTable()}
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const forms = state.searchFTR.listByPage.map((item) => {
    const {answers, generalInfo} = item;
    return {...item, ...answers, ...generalInfo};
  });
  return {
    forms,
    'loading': state.searchFTR.loading,
    'permissions': state.session.permissions,
  };
};

const {
  addMessageBoxError,
  updateStateServiceForm,
  fetchPublishedAnswersList,
  clearPublishedAnswersList,
  navigateTo,
} = Actions;

export default connect(mapStateToProps, {
  navigateTo,
  addMessageBoxError,
  updateStateServiceForm,
  fetchPublishedAnswersList,
  clearPublishedAnswersList,
})(ManintainFTRs);
